import script from "./HomeBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeBlock.vue?vue&type=script&setup=true&lang=js"

import "./HomeBlock.vue?vue&type=style&index=0&id=3f1d5fbb&lang=scss"

const __exports__ = script;

export default __exports__